import VideoRejectedModalComponent from "./VideoRejectedModalComponent";

export default VideoRejectedModalComponent;